import { useDocumentsDataQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { useInvoiceStore } from "../store";

export const useFetchDocumentsData = () => {
  const store = useInvoiceStore();

  const { refetch } = useDocumentsDataQuery({
    variables: {
      brand_ids: store.form.brand_ids.value,
      project_ids: store.form.project_ids.value,
    },
    skip: store.form.brand_ids.value.length === 0,
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      store.setDocumentsWithPdf(data);
    },
    ...onError(),
  });

  store.documentsRefetch = refetch;
};
